module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "roles"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', [
    [_c('b-breadcrumb', {
      staticClass: "breadCrumb",
      attrs: {
        "items": _vm.breadCrumbItems
      }
    })]
  ], 2), _vm._v(" "), _c('p', [_vm._v("Here you can configure role names for your company.")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row mt-3 align-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.manager_role_display_name ? '' : 'Manager'
    },
    model: {
      value: (_vm.formData.manager_role_display_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "manager_role_display_name", $$v)
      },
      expression: "formData.manager_role_display_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 align-items-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.shift_leader_role_display_name ? '' : 'Shift leader'
    },
    model: {
      value: (_vm.formData.shift_leader_role_display_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "shift_leader_role_display_name", $$v)
      },
      expression: "formData.shift_leader_role_display_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 align-items-center"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.basic_role_display_name ? '' : 'Basic user'
    },
    model: {
      value: (_vm.formData.basic_role_display_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "basic_role_display_name", $$v)
      },
      expression: "formData.basic_role_display_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-6 text-right col-md-1"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        Save\n      ")])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Has access to all data of the company and all settings configuration.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Has access to selected areas within the company and can only configure those areas. Has access to the app. Can view reports in the app")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Has access to selected areas within the company can only perform tasks, checklists, audits. Only app access (no web access). Can view reports")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9d7ff3e","hasScoped":false}!./src/components/roles/roles.component.html
// module id = 554
// module chunks = 1